import { constants, getCurrSection, getIsEndBoardZoomed, getItemsInCart, setItemsInCart } from "../model"
import EventBus from "eventing-bus"
import gsap from "gsap"

const viewEl = document.querySelector("#cart-btn-view"),
  badgeEl = viewEl.querySelector(".badge"),
  bagImgEl = viewEl.querySelector("img"),
  itemsInCartEl = viewEl.querySelector(".items-in-cart")

const handleSectionChanged = () => {
  if (getCurrSection() === 3) {
    setTimeout(() => {
      viewEl.classList.add("show")
      if (getItemsInCart() > 0) showBadge()
      else hideBadge()
    }, 6000)
  } else {
    viewEl.classList.remove("show")
  }
}

const handleAddToCartPressed = () => {
  setItemsInCart(getItemsInCart() + 1)
  itemsInCartEl.innerHTML = getItemsInCart()
  showBadge()
  viewEl.addEventListener("click", handleClick)
}

const showBadge = () => {
  const duration = 0.4

  badgeEl.classList.add("show")
  viewEl.addEventListener("click", handleClick)
  viewEl.classList.add("active")
  gsap.to(viewEl, { duration, scale: 1.4, ease: "power4.out" })
  gsap.to(viewEl, { duration, scale: 1, delay: duration - 0.1, ease: "power4.inOut" })
}
const hideBadge = () => {
  badgeEl.classList.remove("show")
  viewEl.removeEventListener("click", handleClick)
  viewEl.classList.remove("active")
}

const handleClick = () => {
  EventBus.publish(constants.CART_BTN_PRESSED)
}

const handleZoom = () => {
  if (getIsEndBoardZoomed()) {
    viewEl.classList.remove("show")
  } else {
    viewEl.classList.add("show")
  }
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
EventBus.on(constants.PLAY_PRODUCT_ZOOM, handleZoom)
EventBus.on(constants.ADD_TO_CART_PRESSED, handleAddToCartPressed)
